(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["faqsmigue"] && !Shopify.designMode) return;
  try {
    
(function () {
  function iniciarFaq(root) {
    var cerrarOtras = root.getAttribute('data-cerrar-otras') === 'true';
    var items = Array.prototype.slice.call(root.querySelectorAll('.pip-faq__item'));

    items.forEach(function (item) {
      var btn = item.querySelector('.pip-faq__pregunta');
      if (!btn) return;
      btn.addEventListener('click', function () {
        var abierto = item.classList.contains('pip-faq__item--abierto');
        if (cerrarOtras) {
          items.forEach(function (otro) {
            otro.classList.remove('pip-faq__item--abierto');
            var b = otro.querySelector('.pip-faq__pregunta');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
        }
        if (abierto) {
          item.classList.remove('pip-faq__item--abierto');
          btn.setAttribute('aria-expanded', 'false');
        } else {
          item.classList.add('pip-faq__item--abierto');
          btn.setAttribute('aria-expanded', 'true');
        }
      });
    });

    var toggle = root.querySelector('.pip-faq__toggle');
    if (toggle) {
      var extras = Array.prototype.slice.call(root.querySelectorAll('[data-extra="true"]'));
      var textoMas = toggle.getAttribute('data-mas');
      var textoMenos = toggle.getAttribute('data-menos');
      toggle.addEventListener('click', function () {
        var expandido = toggle.getAttribute('aria-expanded') === 'true';
        if (expandido) {
          extras.forEach(function (ex) {
            ex.classList.remove('pip-faq__item--abierto');
            var b = ex.querySelector('.pip-faq__pregunta');
            if (b) b.setAttribute('aria-expanded', 'false');
            ex.hidden = true;
          });
          toggle.setAttribute('aria-expanded', 'false');
          toggle.textContent = textoMas;
        } else {
          extras.forEach(function (ex) { ex.hidden = false; });
          toggle.setAttribute('aria-expanded', 'true');
          toggle.textContent = textoMenos;
        }
      });
    }

    var video = root.querySelector('.pip-faq__video');
    var mediaBtn = root.querySelector('.pip-faq__media-btn');
    if (video && mediaBtn) {
      mediaBtn.addEventListener('click', function () {
        if (video.paused) {
          video.play();
          mediaBtn.setAttribute('data-estado', 'reproduciendo');
        } else {
          video.pause();
          mediaBtn.setAttribute('data-estado', 'pausado');
        }
      });
      video.addEventListener('play', function () { mediaBtn.setAttribute('data-estado', 'reproduciendo'); });
      video.addEventListener('pause', function () { mediaBtn.setAttribute('data-estado', 'pausado'); });
    }
  }

  function iniciar() {
    document.querySelectorAll('.pip-faq').forEach(iniciarFaq);
  }

  if (document.readyState !== 'loading') iniciar();
  else document.addEventListener('DOMContentLoaded', iniciar);

  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('.pip-faq');
    if (el) iniciarFaq(el);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
